import { render, staticRenderFns } from "./board-save-success.vue?vue&type=template&id=9e008ba0&scoped=true&"
import script from "./board-save-success.vue?vue&type=script&lang=js&"
export * from "./board-save-success.vue?vue&type=script&lang=js&"
import style0 from "./board-save-success.vue?vue&type=style&index=0&id=9e008ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e008ba0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
